import React from "react";
import PropTypes from "prop-types";
import styles from "./masonry.css";

// Based on React Masonry CSS
// https://github.com/paulcollett/react-masonry-css
class Masonry extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			columnCount: ""
		};

		this.calculateColumns = this.calculateColumns.bind(this);
	}

	componentDidMount() {
		this.calculateColumns();

		if (window) {
			window.addEventListener("resize", this.calculateColumns);
		}
	}

	componentWillReceiveProps() {
		this.calculateColumns();
	}

	componentWillUnmount() {
		if (window) {
			window.removeEventListener("resize", this.calculateColumns);
		}
	}

	calculateColumns() {
		const windowWidth = (window && window.innerWidth) || Infinity;
		const columnBreakpoints = {
			0: 2,
			600: 3,
			1200: 4,
			1500: 5,
			1800: 5,
			2100: 6
		};
		let columns = columnBreakpoints[0];
		let currentBreakpoint = columnBreakpoints[0];

		for (let breakpoint in columnBreakpoints) {
			breakpoint = parseInt(breakpoint, 10);

			if (breakpoint <= windowWidth && breakpoint > currentBreakpoint) {
				currentBreakpoint = breakpoint;
				columns = columnBreakpoints[breakpoint];
			}
		}

		columns = Math.max(
			columnBreakpoints[0],
			parseInt(columns, 10) || columnBreakpoints[0]
		);

		if (this.state.columnCount !== columns) {
			this.setState({
				columnCount: columns
			});
		}
	}

	itemsInColumns() {
		const columnCount = this.state.columnCount;
		const itemsInColumns = new Array(columnCount);
		const items = this.props.children || [];

		items.forEach((item, i) => {
			const columnIndex = i % columnCount;

			if (!itemsInColumns[columnIndex]) {
				itemsInColumns[columnIndex] = [];
			}

			itemsInColumns[columnIndex].push(
				<div className={styles.gridItem}>{item}</div>
			);
		});

		return itemsInColumns;
	}

	renderColumns() {
		const itemsInColumns = this.itemsInColumns();
		const columnWidth = `${100 / itemsInColumns.length}%`;

		return itemsInColumns.map((items, i) => {
			return (
				<div
					key={i}
					className={styles.gridColumn}
					style={{ width: columnWidth }}
				>
					{items}
				</div>
			);
		});
	}

	render() {
		return <div className={styles.grid}>{this.renderColumns()}</div>;
	}
}

Masonry.propTypes = {
	breakpointCols: PropTypes.object
};

Masonry.defaultProps = {
	breakpointCols: {}
};

export default Masonry;



// WEBPACK FOOTER //
// ./src/components/ui/masonry/masonry.js